__webpack_require__.p = "/manage-cards-static/";